import { useQuery } from "@tanstack/react-query";

import { getForeignWorkerApplicantScores } from "../../services/foreign_workers";

import { ICombinedApplicantScores } from "../../interfaces/services";

const useGetForeignWorkerApplicantScores = (foreignWorkerId: string, linked: boolean) => {
    const foreign_worker_id = foreignWorkerId ? parseInt(foreignWorkerId) : 0;

    const queryFn = async (): Promise<ICombinedApplicantScores> => {
        return await getForeignWorkerApplicantScores(foreign_worker_id);
    };

    return useQuery({
        queryKey: ['foreign_worker_applicant_scores', foreign_worker_id],
        queryFn,
        enabled: foreign_worker_id > 0 && linked,
        retry: 0,
    });
};
export default useGetForeignWorkerApplicantScores;